<template><section><template>
<h2>Textarea</h2>
<div class="bs-docs-section">
  <div class="bs-example">
   <n3-textarea v-model="value"></n3-textarea>
  </div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-textarea</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-textarea</span>&gt;</span>
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>resize</td>
<td><code v-pre="">boolean</code></td>
<td><code v-pre="">false</code></td>
<td>resize suggestion</td>
</tr>
<tr>
<td>max-length</td>
<td><code v-pre="">Number</code></td>
<td>-</td>
<td>length limit of value</td>
</tr>
<tr>
<td>max-height</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>max height</td>
</tr>
<tr>
<td>min-height</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>min height</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>blur</td>
<td>blur</td>
</tr>
<tr>
<td>focus</td>
<td>focus</td>
</tr>
<tr>
<td>change</td>
<td>change</td>
</tr>
</tbody>
</table>
<p>PS: params of form components，look <a href="#n3FormDocs">Form</a> </p>
</div>
</template>

</section></template>

<script>

export default {
  data () {
    return {
      value: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3TextareaDocs.md?4967286f